import script from "./fee-discounts.vue?vue&type=script&lang=ts&setup=true"
export * from "./fee-discounts.vue?vue&type=script&lang=ts&setup=true"

import "./fee-discounts.vue?vue&type=style&index=0&id=267e553c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267e553c"]])

export default __exports__